import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Modal,
  Form,
  Input,
  Switch,
  Tree,
  Radio,
  Button,
  Spin,
  Row,
  Col
} from 'antd';
import { EDIT_USER_FORM_NAME } from '../AdminPageConstants';

import './EditUserForm.css';

const { TreeNode } = Tree;

class EditUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderTree: false
    };
  }

  componentDidMount() {
    this.setInitialValues();
  }

  setInitialValues = () => {
    const { form, userData } = this.props;
    form.setFieldsValue({
      id: userData.id,
      name: userData.name,
      email: userData.email,
      // permissions: userData.permissions[0],
      role: _.find(this.props.permissions, { name: userData.role }).id,
      active: userData.active
    });
  };

  handleCreate = () => {
    this.props.onCreate(this.props.form);
  };

  preparePermissionTreeData = () => {
    let permissionData = [
      {
        title: 'User type',
        key: 'permissions',
        children: []
      }
    ];

    _.forEach(this.props.permissions, (permission) => {
      permissionData[0].children.push({
        title: permission.description,
        key: permission.id
      });
    });

    return permissionData;
  };

  renderTreeNodes = (data) =>
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode
            title={item.title}
            key={item.key}
            dataRef={item}
            selectable={false}
          >
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode {...item} selectable={false} />;
    });

  preparePermissionsRadio = () => {
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
      marginLeft: '30px'
    };

    let permissionComponent = [];
    _.forEach(this.props.permissions, (permission) => {
      permissionComponent.push(
        <Radio
          style={radioStyle}
          value={permission.id}
          key={`radio_index_${permission.id}`}
        >
          {permission[this.props.permissionKey]}
        </Radio>
      );
      // permissionData[0].children.push({
      //   title: permission.description,
      //   key: permission.id,
      // })
    });

    return permissionComponent;
  };

  render() {
    const { isVisible, onCancel, form, userData, loaderIsVisible } = this.props;

    const permissionData = this.preparePermissionTreeData();
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 10, className: 'label-container' },
      wrapperCol: { span: 14 }
    };

    const customFormItemLayout = {
      labelCol: { span: 14, className: 'custom-label-container' },
      wrapperCol: { span: 10 }
    };

    return (
      <div>
        <Modal
          title={`Edit - ${userData.email}`}
          // okText="Save"
          // cancelText="Cancel"
          visible={isVisible}
          // onOk={this.handleCreate}
          onCancel={onCancel}
          keyboard={false}
          maskClosable={false}
          width={620}
          footer={[
            <Button key='back' loading={loaderIsVisible} onClick={onCancel}>
              Cancel
            </Button>,
            <Button
              key='submit'
              type='primary'
              loading={loaderIsVisible}
              onClick={this.handleCreate}
            >
              Save
            </Button>
          ]}
        >
          <Spin size='large' spinning={loaderIsVisible}>
            <Row className='userEditForm'>
              <Form layout='horizontal' prefixCls='add_new_template_'>
                <Col xs={24}>
                  <Form.Item label='User name'>
                    {getFieldDecorator('name', {
                      rules: [
                        {
                          required: true,
                          message: 'This field cannot be empty.'
                        }
                      ]
                    })(<Input />)}
                  </Form.Item>
                </Col>
                {/*<Form.Item label="Enail">*/}
                {/*  {getFieldDecorator('email')(*/}
                {/*    <Input disabled={true}/>,*/}
                {/*  )}*/}
                {/*</Form.Item>*/}
                <Col xs={24}>
                  <Form.Item
                    label={`Account ${
                      form.getFieldValue('active') ? 'active' : 'disabled'
                    }`}
                    {...formItemLayout}
                  >
                    {getFieldDecorator('active', {
                      valuePropName: 'checked'
                    })(<Switch />)}
                  </Form.Item>
                </Col>
                <Col xs={8}>
                  <Form.Item label='User type'>
                    {getFieldDecorator('role', {
                      rules: [
                        {
                          required: true,
                          message: 'This field cannot be empty.'
                        }
                      ]
                    })(
                      <Radio.Group>
                        {this.preparePermissionsRadio(permissionData)}
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
                <Col xs={16}>
                  <Col xs={24}>
                    <div className='custom-label'>
                      <span>Pages permission:</span>
                    </div>
                  </Col>
                  <Col xs={12}>
                    <Form.Item label='Images' {...customFormItemLayout}>
                      {getFieldDecorator('imagePermission', {
                        valuePropName: 'checked',
                        initialValue: this.props.userData.imagePermission
                      })(<Switch />)}
                    </Form.Item>
                    <Form.Item label='Quality' {...customFormItemLayout}>
                      {getFieldDecorator('qualityControlPermission', {
                        valuePropName: 'checked',
                        initialValue:
                          this.props.userData.qualityControlPermission
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item label='Review' {...customFormItemLayout}>
                      {getFieldDecorator('reviewPermission', {
                        valuePropName: 'checked',
                        initialValue: this.props.userData.reviewPermission
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item label='Social Media' {...customFormItemLayout}>
                      {getFieldDecorator('socialMediaPermission', {
                        valuePropName: 'checked',
                        initialValue: this.props.userData.socialMediaPermission
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item label='Search' {...customFormItemLayout}>
                      {getFieldDecorator('tablePermission', {
                        valuePropName: 'checked',
                        initialValue: this.props.userData.tablePermission
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item label='Import' {...customFormItemLayout}>
                      {getFieldDecorator('importPermission', {
                        valuePropName: 'checked',
                        initialValue: this.props.userData.importPermission
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col xs={12}>
                    <Form.Item label='Image Upload' {...customFormItemLayout}>
                      {getFieldDecorator('imageUploadPermission', {
                        valuePropName: 'checked',
                        initialValue: this.props.userData.imageUploadPermission
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <Form.Item
                      label='Image Management'
                      {...customFormItemLayout}
                    >
                      {getFieldDecorator('imageManagementPermission', {
                        valuePropName: 'checked',
                        initialValue:
                          this.props.userData.imageManagementPermission
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <Form.Item
                      label='Legitimate sighting status'
                      {...customFormItemLayout}
                    >
                      {getFieldDecorator('legitimateStatusPermission', {
                        valuePropName: 'checked',
                        initialValue:
                          this.props.userData.legitimateStatusPermission
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <Form.Item
                      label='Domain Management'
                      {...customFormItemLayout}
                    >
                      {getFieldDecorator('domainPermission', {
                        valuePropName: 'checked',
                        initialValue: this.props.userData.domainPermission
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                </Col>
                {/* <Col xs={8}>
                  <div className="custom-label">
                    <span>Tables:</span>
                  </div>
                </Col> */}
                <Col xs={24}>
                  <Form.Item>
                    <Button
                      type='primary'
                      htmlType='button'
                      onClick={(event) => this.props.onChangePassword(event)}
                    >
                      Change password
                    </Button>
                  </Form.Item>
                </Col>
              </Form>
            </Row>
          </Spin>
        </Modal>
      </div>
    );
  }
}

EditUserForm.propTypes = {
  isVisible: PropTypes.bool,
  loaderIsVisible: PropTypes.bool,
  onCancel: PropTypes.func,
  onCreate: PropTypes.func,
  userData: PropTypes.object,
  permissions: PropTypes.array,
  permissionKey: PropTypes.string,
  onChangePassword: PropTypes.func
};

export default Form.create({ name: EDIT_USER_FORM_NAME })(EditUserForm);
